import React from "react"
import PropTypes from "prop-types"
import { Input } from "@tencent/spaui"
import parsePhone from "@/utils/PhoneUtils"

class PhoneInput extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    className: PropTypes.string,
    extension: PropTypes.bool,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    extension: true,
  }

  state = {}

  render() {
    const { value, className, disabled } = this.props
    return <Input className={`TelephoneInput ${className}`} value={value} onChange={this.handleChange} disabled={disabled} />
  }

  handleChange = (e, value) => {
    const phone = parsePhone(value.trim())
    const { extension } = this.props
    if (!extension && (phone.extension || (phone.error && phone.error.indexOf("分机") > -1))) {
      phone.error = "不支持分机"
    }
    this.setState(
      {
        phone,
      },
      () => {
        this.props.onChange(e, phone)
      }
    )
  }
}

export default PhoneInput
